var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AddressInfo',{staticClass:"ship-to",attrs:{"field":"toAddress","item":_vm.item}})
}
var staticRenderFns = []

export { render, staticRenderFns }